"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetRatings = exports.storeRatings = exports.fetchRatings = exports.sendRatings = void 0;

var _types = require("./types"); //origin refers to the page where the action is fired.
//could be from treks, lodge or profile


var sendRatings = function sendRatings(ratings, origin, token) {
  return {
    type: _types.SEND_RATINGS,
    ratings: ratings,
    origin: origin,
    token: token
  };
};

exports.sendRatings = sendRatings;

var fetchRatings = function fetchRatings(origin) {
  return {
    type: _types.FETCH_RATINGS,
    origin: origin
  };
};

exports.fetchRatings = fetchRatings;

var storeRatings = function storeRatings(ratings, origin) {
  return {
    type: _types.STORE_RATINGS,
    origin: origin,
    ratings: ratings
  };
};

exports.storeRatings = storeRatings;

var resetRatings = function resetRatings() {
  return {
    type: _types.RESET_RATINGS
  };
};

exports.resetRatings = resetRatings;